/**
 * Beyond Certification description enums for Agent Platform Subscription and Non Agent Platform Subscription
 * Used to display certification description on the subscription detail page
 */
export enum CertificationDescription {
  AGENT_PLATFORM_SUBSCRIPTION_CERTIFICATION_DESCRIPTION = 'Test your skills and knowledge of Genesys Cloud with the Genesys Cloud Certified Agent exam.',
  NON_AGENT_PLATFORM_SUBSCRIPTION_CERTIFICATION_DESCRIPTION = 'Genesys offers different levels of certifications across various Genesys product platforms.',
}
